// Lazy Image Sizes
import 'lazysizes';

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.loadMode = 1;